import { WebviewTheme } from '@shared/types/webview';
import actionCreatorFactory from 'typescript-fsa';
import { NAMESPACE } from './constants';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const setClientWidth = actionCreator<number>('WIDTH_UPDATED');
export const setClientHeight = actionCreator<number>('HEIGHT_UPDATED');
export const setWebviewOs = actionCreator<boolean | string>('WEBVIEW_OS_UPDATED');
export const setWebviewTheme = actionCreator<undefined | WebviewTheme>('WEBVIEW_THEME_UPDATED');
export const setClientOffsetTop = actionCreator<number>('SET_CLIENT_OFFSET_TOP');
export const setTabVisibility = actionCreator<boolean>('SET_TAB_VISIBILITY');
